import React from "react";

import { useRecoilValueLoadable } from "recoil";
import { aspectType, asyncGetAspectList } from "lib/store/dashboard";

import { StackedBarChart } from ".";
import { Skeleton } from "components/atom/Skeleton";
import { SentimentIcons } from "components/atom/SentimentIcons";

import "./SentimentSummary.scss";

export type SentimentSummaryProps = {
  cx?: string;
};

export const SentimentSummary: React.FC<SentimentSummaryProps> = ({
  cx = "",
}) => {
  const { state, contents } = useRecoilValueLoadable(asyncGetAspectList);
  return (
    <div className={`SentimentSummary ${cx}`}>
      <div className="header">
        <span className="title">Sentiment Summary</span>
        <SentimentIcons />
      </div>
      {state === "hasValue" ? (
        <div className={"scroll-wrapper"}>
          {contents.map(
            ({ aspect, positive, negative, neutral }: aspectType) => (
              <StackedBarChart
                key={`${aspect}-chart`}
                aspect={aspect}
                positive={positive}
                negative={negative}
                neutral={neutral}
              />
            )
          )}
        </div>
      ) : (
        <div className={"skeleton-wrapper"}>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      )}
    </div>
  );
};
